import { OnInit, Component, Optional, Inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { NxiContextUtils } from '@pershing/nxi-common';
import { NxiRestService } from '../../../../services/NXI-Rest.service';
import { EventEmitterService } from '../../../../services/EventEmitterService.component';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
    selector: 'Maturity-Schedule-Grid',
    templateUrl: './MaturityScheduleGrid.component.html',
    styleUrls: ['./MaturityScheduleGrid.component.css']
})

export class MaturityScheduleGrid implements OnInit {
    da: any;
    down: any;
    subs: Subscription;
    acctRef: any;
    isDisabled: Boolean = false;
    serviceUrl: any;
    activeSort: any;
    reverseSort: boolean;
    ismobile: boolean = false;
    isAda: boolean = false;
    constructor(private eventEmitterService: EventEmitterService, private contextService: IContextService, private nxiRestService: NxiRestService,
                private translationService: PershingTranslationService, @Optional() @Inject('AppSettings') appSettings: any) {
                this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
                if (appSettings.deviceType === 'mobile') {
                    this.ismobile = true;
                 }
                if (appSettings.themeType === 'ada') {
                    this.isAda = true;
                }
                }
    ngOnInit() {
        this.serviceUrl = this.nxiRestService.serviceUrl;
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.acctRef = contextValue.hashValue;
            this.download();
        });
        if (this.eventEmitterService.subsVar1 === undefined) {
            this.eventEmitterService.subsVar1 = this.eventEmitterService.invokeMaturityFunction.subscribe((name: string) => {
              this.firstFunction();
            });
    }
    }

    download() {
        this.down = (this.serviceUrl + '/trading/' + this.acctRef + '/maturitySchedule/?isDownload=true&localeParam=en_US&maturityTimePeriod=6&isGDR=true');
    }

    firstFunction() {
        this.da = this.eventEmitterService.getda();
        // for (let i of this.da.maturitySchedule) {
        //         i['showDiv'] = 'false';
        // }
    }
    sort(att) {
        if ( att === this.activeSort) {
          this.reverseSort = !this.reverseSort;
          if (!this.reverseSort) {
            this.da.maturitySchedule.sort((a, b) => (a[att] > b[att]) ? 1 : -1);
          }else {
            this.da.maturitySchedule.sort((a, b) => (a[att] < b[att]) ? 1 : -1);
          }
        }else {
          this.activeSort = att;
          this.reverseSort = false;
          this.da.maturitySchedule.sort((a, b) => (a[att] > b[att]) ? 1 : -1);
        }
    }

}
